export enum PubsubEventTypeEnum {
  TASKS = "task",
  NOTIFICATIONS = 'notifications'
}